import React from 'react';
import { Route, Routes } from 'react-router-dom';

import SecureRoute from 'ui/components/Route/SecureRoute';

import { Routes as ReportsRoutes } from './routes';
import { ReportsPage } from '../pages';
import { ReportsRouterCmp, ReportsRouterProps } from './types';
import { InsightsPage } from '../pages/InsightsPage';
import { TemplatesPage } from '../pages/TemplatesPage';
import { PermissionType } from 'services/permissions';
import { useSelector } from 'react-redux';
import { getInsightsEntitlement } from 'services/insights';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ReportsRouter: ReportsRouterCmp = (props: ReportsRouterProps) => {
  const insightEntitlement = useSelector(getInsightsEntitlement);

  return (
    <Routes>
      <Route element={<SecureRoute />}>
        <Route index element={<ReportsPage />} />
        <Route path={ReportsPage.route} element={<ReportsPage />} />
      </Route>
      <Route
        element={
          <SecureRoute
            permissions={[PermissionType.AiInsightsViewEdit]}
            featureFlag="aiInsights"
            redirectToHome={!insightEntitlement}
          />
        }
      >
        <Route element={<InsightsPage />} path={InsightsPage.route} />
      </Route>
      <Route
        element={
          <SecureRoute
            featureFlag="templateDesigner"
            requiredFeature="canAccessTemplates"
          />
        }
      >
        <Route path={TemplatesPage.route} element={<TemplatesPage />} />
      </Route>
    </Routes>
  );
};

ReportsRouter.route = ReportsRoutes.ReportsRouter;

export default ReportsRouter;
